export default "__VITE_ASSET__Bn$XrqA8__"